module.exports = __webpack_public_path__ + "media/images/expert__joas-balmelli-ba06e60ed37227f3ee3930e7b1f94d5c.png";